import React from 'react';
import { Button, SvgIcon, Badge } from '@gik/ui';
import { useTranslation } from 'react-i18next';
import bemBlock from '@gik/core/utils/bemBlock';
import { inkindPageTourSelectors } from '@gik/inkind-page/components/InkindPageTour/InkindPageTour';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import Link from '@/components/Link';
import { useInkindStore } from '@gik/inkind/store/InkindStore';

type InkindSupportersButtonProps = {
  num: number;
};

export default function InkindSupportersButton({ num }: InkindSupportersButtonProps): JSX.Element {
  const { t } = useTranslation();
  const bem = bemBlock('inkind-supporters-button');
  const inkindRouteId = useInkindStore(store => store.inkindRouteId);

  return (
    <Link href={`/inkinds/${inkindRouteId}/admin/supporters`}>
      <Button
        id={inkindPageTourSelectors.supportersButton}
        className={bem()}
        block
        pill
        size="lg"
        customIconSize
        variant="secondary"
        prepend={<SvgIcon name="UserGroup" />}
        append={
          <Badge size="xs" variant="white" pill>
            {num}
          </Badge>
        }
      >
        {t(translationKeys.SupportersButton)}
      </Button>
    </Link>
  );
}
